import React, { useState, useEffect, useRef, useCallback } from 'react';
import { testimonials } from '../../data/testimonials';
import './TestimonialsSection.css';

// Reusable testimonial card component
function TestimonialCard({ testimonial }) {
  return (
    <div className="testimonialCardShell">
      <div className="testimonials__story">
        <div className="testimonials__storyText">
          {/* School heading with logo + name */}
          <div className="testimonials__schoolRow">
            <div className="testimonials__schoolLogoCircle">
              {testimonial.logo && (
                <img
                  src={testimonial.logo}
                  alt={testimonial.school}
                />
              )}
            </div>
            <div className="testimonials__schoolTitle">
              {testimonial.school}
            </div>
          </div>

          <div className="testimonials__schoolStars">
            ★★★★★
          </div>

          <p className="testimonials__quote">
            "{testimonial.quote}"
          </p>

          <div className="testimonials__author">
            <div className="testimonials__authorName">
              {testimonial.name}
            </div>
            <div className="testimonials__authorSchool">
              {testimonial.school}
            </div>
            {testimonial.verified && (
              <span className="testimonial-badge">✓ Verified Student</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

function TestimonialsSection() {
  const trackRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const scrollNextOne = useCallback(() => {
    const el = trackRef.current;
    if (!el) return;

    const items = el.querySelectorAll(".dh-carousel-item");
    if (!items || items.length === 0) return;

    // Calculate next index
    const nextIndex = (currentIndex + 1) % items.length;
    setCurrentIndex(nextIndex);

    // Get the scroll position for the next item
    const item = items[nextIndex];
    if (item) {
      const scrollLeft = item.offsetLeft;
      el.scrollTo({ left: scrollLeft, behavior: "smooth" });
    }
  }, [currentIndex]);

  useEffect(() => {
    const id = setInterval(scrollNextOne, 7000);
    return () => clearInterval(id);
  }, [currentIndex, scrollNextOne]);

  return (
    <section 
      id="testimonials" 
      className="testimonials" 
      style={{ 
        backgroundImage: 'url(/other_images/chalkboard.avif)',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
      }}
      aria-live="polite" 
      aria-label="Student testimonials"
    >
      <div className="container">
        <h2 className="section-title">Loved by students everywhere</h2>
        
        {/* 3-Up Testimonial Carousel */}
        <div className="dh-carousel-container">
          <div className="dh-carousel-viewport">
            <div className="dh-carousel-track" ref={trackRef}>
              {testimonials.map((t, i) => (
                <div className="dh-carousel-item" key={t.schoolId ?? i}>
                  <TestimonialCard testimonial={t} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TestimonialsSection;
